"use client"
import { ComponentConfig } from "@measured/puck"
import { commonStylesProps } from "../../../lib/commonCSSProps"
import { FormCustomizeTour, RenderConfig } from "./RenderConfig"

export const CCAFormCustomizeTour: ComponentConfig<FormCustomizeTour> = {
  label: "CCA | Form Customize Tours",
  //@ts-ignore
  fields: {
    title: {
      label: "Title",
      type: "text",
    },
    description: {
      label: "Description",
      type: "text",
    },
    isShowTitle: {
      label: "Show Title",
      type: "radio",
      options: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
    },
    isShowDescription: {
      label: "Show Description",
      type: "radio",
      options: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
    },

    ...commonStylesProps,
  },
  defaultProps: {
    title: "Design Your Itinerary",
    description:
      "By listening to our customers and crafting diverse, exciting, and safe tours, Cao Cao Adventures can become the go-to choice for your unforgettable cycling experiences in Vietnam.",
    isShowTitle: true,
    isShowDescription: true,
    className: "",
    styles: {
      mobile: {
        display: "block",
      },
      tablet: {
        display: "block",
      },
      desktop: {
        display: "block",
      },
    },
  },
  ...RenderConfig,
}
export { RenderConfig }
